import React from 'react';

import { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';

import GenericList from '@ts-core/core/components/GenericList';

import { StudentActivity } from '../../types';
import StudentActivityCard from '../StudentActivityCard';

interface StudentActivitiesListProps {
  sx?: SxProps;
  activities?: StudentActivity[];
  loading: boolean;

  onActivityActionClick?: (activity: StudentActivity) => void;
}

const StudentActivitiesList = (props: StudentActivitiesListProps) => {
  const { loading, activities, onActivityActionClick, sx } = props;
  return (
    <Box sx={sx}>
      <GenericList
        items={activities}
        loading={loading}
        skeletonsCount={3}
        emptyMessage="No hay tareas para mostrar"
        renderItem={(index, activity) => (
          <StudentActivityCard key={index} activity={activity} loading={loading} onActivityActionClick={onActivityActionClick} />
        )}
      />
    </Box>
  );
};

export default StudentActivitiesList;
